import { render, staticRenderFns } from "./registerAgent.vue?vue&type=template&id=3c0c4dc2&"
import script from "./registerAgent.vue?vue&type=script&lang=js&"
export * from "./registerAgent.vue?vue&type=script&lang=js&"
import style0 from "./registerAgent.vue?vue&type=style&index=0&id=3c0c4dc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports